import React, { useEffect, useMemo, useRef, useState } from "react";
import { Platform } from "react-native";
import useDevicePlatform, {
  DeviceType,
} from "../../hooks/useDevicePlatform.hook";
import moment from "moment";
import CalendarAttendanceReportsWeb from "./CalendarAttendanceReportsWeb.component";
import CalendarAttendanceReportsMobileContainer from "./CalendarAttendanceReportsMobileWeb.container";
import { useDispatch, useSelector } from "react-redux";
import { setChosenDate } from "../../store/actions/clockReport.actions";
import { getChosenDate } from '../../store/selectors/clockReport.selector';
import { useMonthAttendance } from '../../services/hooks/useMonthAttendance.hook';

const CalendarAttendanceReports = ({ navigation }: { navigation: any }) => {
	const dispatch = useDispatch();
	const calendarChosenDate = useSelector(getChosenDate);

  const devicePlatformRef = useRef<DeviceType>(useDevicePlatform());
  const isMobile = devicePlatformRef.current !== DeviceType.WEB;

	const dateRef = calendarChosenDate || moment().format('YYYY-MM-DD');
	const month = moment(dateRef, 'YYYY-MM-DD').month() + 1;
	const year = moment(dateRef, 'YYYY-MM-DD').year();
	const monthlyAttendanceData = useMonthAttendance({ month, year });

  useEffect(() => {
    onMount();
    return () => {
      dispatch(setChosenDate(moment().format('YYYY-MM-DD')))
    }
  }, []);

  const onMount = async () => {
    if (Platform.OS !== 'web') {
      const crashlytics = (
        await import('@react-native-firebase/crashlytics')
      ).default;
      crashlytics().log('CalendarAttendanceReports');
    }
  }

	return (
		<>
			{isMobile ? (
				<CalendarAttendanceReportsMobileContainer
					navigation={navigation}
					monthlyAttendanceData={monthlyAttendanceData}
				/>
			) : (
				<CalendarAttendanceReportsWeb
					navigation={navigation}
					monthlyAttendanceData={monthlyAttendanceData}
				/>
			)}
		</>
	);
};

export default CalendarAttendanceReports;
